import { useState, useEffect } from "react"
import { Modal, notification } from "components/ui"
import { TelegramShareButton, TwitterShareButton, FacebookShareButton, FacebookMessengerShareButton } from "react-share"
import axios from "axios"

export default function SharePost({ initVideo, showPopup }) {
  const [isShow, setIsShow] = useState(false)
  const [linkShare, setLinkShare] = useState("")
  const [loadingLink, setLoadingLink] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const { type, id } = initVideo

  function onCancel() {
    setIsShow(false)
  }

  useEffect(() => {
    async function getLink() {
      try {
        setLoadingLink(true)
        const { data } = await axios.get(`${process.env.NEXT_PUBLIC_SHARE}/api/v1/sortlink`, {
          params: { id, type }
        })
        setLinkShare(data.data)
      } catch (error) {
        console.log(error)
      } finally {
        setLoadingLink(false)
      }
    }

    if (!loadingLink) {
      getLink()
    }

    return () => {
      setLinkShare("")
    }
  }, [id])

  // useEffect(() => {
  //   if (isShow) {
  //     setTimeout(() => {
  //       if (window) {
  //         let script = document.createElement("script")
  //         script.src = "https://sp.zalo.me/plugins/sdk.js"
  //         document.getElementsByTagName("head")[0].appendChild(script)
  //       }
  //     }, 500)
  //   }
  // }, [isShow])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    if (showPopup) {
      setIsShow(true)
    }
  }, [showPopup])

  function onCopy(url) {
    navigator.clipboard.writeText(url)
    notification.success({ message: "Sao chép link thành công!" })
  }

  return (
    <>
      <button
        className="flex border border-[#3A3A3A] bg-[#2E2E2E] text-white font-medium items-center py-2 px-5 gap-2 text-sm rounded-xl whitespace-nowrap max-md:hidden"
        onClick={() => setIsShow(true)}
        disabled={loadingLink}
      >
        <img src="/icons/iconShare.svg" /> {!isMobile && "Chia sẻ"}
      </button>

      <Modal isOpen={isShow} onCancel={onCancel} showIcon={false}>
        <div className="relative overflow-x-auto bg-[#1A1A1ADE] text-[#FAFAF9] pt-5 px-10 max-sm:px-3.5 pb-8 max-sm:max-w-[100vw]">
          <button className="absolute top-3 right-5" onClick={onCancel}>
            <img src="/icons/iconBigClose.svg" />
          </button>
          <div className="flex flex-col gap-5 w-[477px] max-sm:max-w-[100vw] max-sm:w-full">
            <div className="font-semibold text-[22px] leading-[30px]">Chia sẻ</div>
            <div className="flex flex-col gap-2">
              <div className="flex justify-between px-2">
                <FacebookShareButton appid="557816459623803" url={linkShare} disabled={!linkShare}>
                  <div className="flex flex-col gap-1 items-center">
                    <div className="flex justify-center">
                      <img src="/icons/iconFacebookLarge.svg" width={isMobile && 54} />
                    </div>
                    <div className="text-xs sm:text-base sm:leading-5 text-white font-normal">Facebook</div>
                  </div>
                </FacebookShareButton>

                <TwitterShareButton url={linkShare} disabled={!linkShare}>
                  <div className="flex flex-col gap-1 items-center">
                    <div className="flex justify-center">
                      <img src="/icons/iconXLarge.svg" width={isMobile && 54} />
                    </div>
                    <div className="text-xs sm:text-base sm:leading-5 text-white font-normal">X</div>
                  </div>
                </TwitterShareButton>

                <TelegramShareButton url={linkShare} disabled={!linkShare}>
                  <div className="flex flex-col gap-1 items-center">
                    <div className="flex justify-center">
                      <img src="/icons/iconTelegramLarge.svg" width={isMobile && 54} />
                    </div>
                    <div className="text-xs sm:text-base sm:leading-5 text-white font-normal">Telegram</div>
                  </div>
                </TelegramShareButton>

                <FacebookMessengerShareButton appid="557816459623803" url={linkShare} disabled={!linkShare}>
                  <div className="flex flex-col gap-1 items-center">
                    <div className="flex justify-center">
                      <img src="/icons/iconMessengerLarge.svg" width={isMobile && 54} />
                    </div>
                    <div className="text-xs sm:text-base sm:leading-5 text-white font-normal">Messenger</div>
                  </div>
                </FacebookMessengerShareButton>

                <div className="flex flex-col gap-1 items-center">
                  <div className="flex justify-center">
                    <button
                      className="zalo-share-button block cursor-pointer"
                      data-href={linkShare}
                      data-oaid="579745863508352884"
                      data-layout="1"
                      data-color="blue"
                      data-customize="true"
                    >
                      <img src="/icons/iconZaloLarge.svg" width={isMobile && 54} />
                    </button>
                  </div>
                  <div className="text-xs sm:text-base sm:leading-5 text-white font-normal">Zalo</div>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-secondary text-sm leading-[18px] font-normal">URL</div>
              <div className="flex justify-between gap-3">
                <div className="overflow-x-hidden overflow-ellipsis bg-[#2E2E2E] text-base leading-5 text-[#afafaf] font-normal py-3 px-4 rounded-xl">
                  {linkShare}
                </div>
                <button
                  onClick={() => onCopy(linkShare)}
                  className="text-base text-[#fafaf9] rounded-xl bg-primary py-2.5 px-7 whitespace-nowrap hover:bg-[#104FA3]"
                >
                  Sao chép
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
